// src/components/shared/DiscountInput.js
// A discount value with a % / $ switch. The parent keeps `type`
// ('percentage' | 'fixed') and `value` (string, so partial input like "7."
// survives typing); see utils/discount.js for the math.
import React from 'react';
import styled from 'styled-components';
import { FaDollarSign, FaPercent } from 'react-icons/fa';
import Input from './Input';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(1)};
  flex: 1;

  > div:last-child {
    flex: 1;
  }
`;

const Toggle = styled.div`
  display: inline-flex;
  border: 1px solid ${(props) => props.theme.colors.inputGray};
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
`;

const ToggleButton = styled.button`
  border: none;
  padding: 12px 14px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  background: ${(props) => (props.$active ? props.theme.colors.primary : props.theme.colors.surface)};
  color: ${(props) => (props.$active ? '#fff' : props.theme.colors.textPrimary)};
`;

const DiscountInput = ({ type, value, onTypeChange, onValueChange, label = 'Discount', error }) => {
  const isFixed = type === 'fixed';
  return (
    <Row>
      <Toggle role="group" aria-label="Discount type">
        <ToggleButton type="button" $active={!isFixed} aria-pressed={!isFixed} onClick={() => onTypeChange('percentage')}>
          %
        </ToggleButton>
        <ToggleButton type="button" $active={isFixed} aria-pressed={isFixed} onClick={() => onTypeChange('fixed')}>
          $
        </ToggleButton>
      </Toggle>
      <Input
        label={isFixed ? `${label} ($)` : `${label} (%)`}
        icon={isFixed ? <FaDollarSign /> : <FaPercent />}
        type="number"
        min="0"
        max={isFixed ? undefined : '100'}
        step="0.01"
        inputMode="decimal"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={isFixed ? 'Amount off' : 'Percent off'}
        error={error}
      />
    </Row>
  );
};

export default DiscountInput;
